import { Button, Row, Space } from 'antd';
import React from 'react';
import { CompWithStepsProps, contentStyling } from '../constants/constants';
import { stepItems } from '../constants/steps';

export const StepsNavigation = React.memo(
  ({ currentStep, form, setCurrentStep }: CompWithStepsProps) => {
    const resetFields = () => form.resetFields();
    const changeStep = (stepChange: number) => {
      form
        .validateFields()
        .then(() => {
          setCurrentStep(currentStep + stepChange);
        })
        .catch((errorInfo) => {
          console.error('Validation failed:', errorInfo);
        });
    };

    return (
      <div style={contentStyling}>
        <Row justify="end">
          <Space>
            {currentStep === 0 && (
              <Button onClick={resetFields}>Išvalyti</Button>
            )}
            {currentStep !== 0 && (
              <Button onClick={() => changeStep(-1)}>Atgal</Button>
            )}
            {currentStep !== stepItems.length - 1 && (
              <Button onClick={() => changeStep(1)}>Kitas</Button>
            )}
          </Space>
        </Row>
      </div>
    );
  },
);
